import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/mdx-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Npm`}</h1>
    <h2>{`Run local developement project`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm run dev
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      